"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransactionIdT = exports.TransactionId = void 0;
class TransactionId {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    /**
     * This is expected to overflow, networking logic should handle this case.
     */
    id() {
        return this.bb.readUint32(this.bb_pos);
    }
    static sizeOf() {
        return 4;
    }
    static createTransactionId(builder, id) {
        builder.prep(4, 4);
        builder.writeInt32(id);
        return builder.offset();
    }
    unpack() {
        return new TransactionIdT(this.id());
    }
    unpackTo(_o) {
        _o.id = this.id();
    }
}
exports.TransactionId = TransactionId;
class TransactionIdT {
    constructor(id = 0) {
        this.id = id;
    }
    pack(builder) {
        return TransactionId.createTransactionId(builder, this.id);
    }
}
exports.TransactionIdT = TransactionIdT;
